import { API_V4 } from "@/services/config/auth-axios";

class OfflinePaymentService {
  getAccount() {
    return API_V4.get("/offline-payment/accounts");
  }
  storePayment(data) {
    return API_V4.post("/offline-payment/store", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  getPayment(id) {
    return API_V4.get(`/offline-payment/${id}`);
  }
  getOfflineDepositAccount() {
    return API_V4.get("/offline-payment/deposit-ids");
  }
  getOfflinePaymentData(page) {
    return API_V4.get(`/offline-payment/index?page=${page}`);
  }
  getOfflinePaymentWithIdentifierData() {
    return API_V4.get(`/offline-payment-with-identifier/gateways`);
  }
  generateOfflinePaymentWithIdentifierData(gateway_id) {
    return API_V4.post(`/offline-payment-with-identifier/identifiers`, {
      gateway_id
    });
  }
  getOfflinePaymentWithIdentifierTransactions(page) {
    return API_V4.get(
      `/offline-payment-with-identifier/transactions?page=${page}`
    );
  }
  getOfflinePaymentWithIdentifierPageDetails() {
    const lang = localStorage.getItem("lang");
    return API_V4.get(`/core/pages/offline-payment-with-identifier/${lang}`);
  }
}

export default new OfflinePaymentService();
